import React, { FC } from 'react';

import { CellContext } from '@tanstack/react-table';

import { EntitlementsProject } from '@adsk/alloy-provider';
import { Flex } from '@adsk/alloy-react-box';
import HighlightText from '@adsk/alloy-react-highlight-text';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { useUrlParams } from '../../../hooks/useFilters';

export const NumberCell: FC<
  CellContext<EntitlementsProject, EntitlementsProject['jobNumber']>
> = ({ row, getValue }) => {
  const [searchParams] = useUrlParams();
  const search = Object.fromEntries(searchParams)?.search;
  const value = getValue();
  return (
    <Flex data-testid={`jobNumber:${row.original.jobNumber}`} pr={3}>
      <OverflowTooltip triggerTarget={OverflowTooltip.TRIGGER_TARGETS.TOOLTIP}>
        <HighlightText matched={search} text={value as string} />
      </OverflowTooltip>
    </Flex>
  );
};
